import TextArea from 'antd/lib/input/TextArea'
import React from 'react'
import { scrollaInIVy } from '../tangentbord'
import { MalindexConfig, MalindexMal, MalindexOmrade } from '../../../api/malindex/malindexApi'
import MalRedigerare from './MalRedigerare'

/**
 * Fördjupning & mål – sista steget i båda flödena, identiskt i kartläggning och
 * uppföljning och därför delat.
 *
 * Två spalter: fördjupningsfrågorna till vänster som stöd medan man pratar,
 * målformuleringen till höger. De hör ihop i samtalet – man läser en fråga och
 * skriver ned svaret som mål – så att lägga dem under varandra skulle tvinga fram
 * scroll mellan två saker man använder samtidigt.
 *
 * Anteckningen ligger i full bredd under spalterna: den gäller hela besöket, inte
 * bara målen. Knapparna ligger utanför komponenten, i flödets gemensamma knapprad.
 */

export interface FordjupningOchMalProps {
  config: MalindexConfig
  /** De stjärnmärkta områdena – deras fördjupningsfrågor visas som stöd. */
  prioOmraden: MalindexOmrade[]
  mal: MalindexMal[]
  onAndraMal: (mal: MalindexMal[]) => void
  note: string
  onAndraNote: (note: string) => void
}

const FordjupningOchMal: React.FC<FordjupningOchMalProps> = ({
  config,
  prioOmraden,
  mal,
  onAndraMal,
  note,
  onAndraNote,
}) => (
  <div className="flex flex-1 flex-col gap-5">
    <div className="grid gap-5 md:grid-cols-2">
      <div>
        <p className="mb-2 text-base font-semibold text-gray-800">Fördjupningsfrågor</p>
        {prioOmraden.length === 0 ? (
          <p className="rounded-lg border border-dashed border-gray-200 bg-gray-50 px-3 py-3 text-base text-gray-500">
            Inga områden prioriterade. Gå tillbaka och stjärnmarkera dem ni väljer ut tillsammans.
          </p>
        ) : (
          <div className="flex flex-col gap-3">
            {prioOmraden.map((o) => (
              // Grå, inte blå. Blått är reserverat för det man kan trycka på eller har
              // tryckt på – fördjupningsfrågorna är läsunderlag. Som blå yta var de
              // dessutom det tyngsta på skärmen, medan handlingen (formulera målet)
              // låg som en tunn kontur bredvid.
              <div key={o.id} className="rounded-lg border border-gray-200 bg-gray-50 px-3 py-2.5">
                <p className="text-base font-semibold text-gray-800">{o.namn}</p>
                <ul className="mt-1.5 list-disc space-y-1.5 pl-5 text-base leading-snug text-gray-700">
                  {o.fordjupningsfragor.map((f, i) => (
                    <li key={i}>{f}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        )}
      </div>

      <MalRedigerare config={config} mal={mal} onAndra={onAndraMal} />
    </div>

    {/* Full bredd – anteckningen gäller besöket, inte målen. */}
    <div>
      <label className="mb-1 block text-base text-gray-600">Anteckning om besöket (valfritt)</label>
      <TextArea
        value={note}
        onChange={(e) => onAndraNote(e.target.value)}
        placeholder="Övrigt om besöket…"
        autoSize={{ minRows: 2, maxRows: 4 }}
        onFocus={scrollaInIVy}
            style={{ resize: 'none', fontSize: 16 }}
      />
    </div>
  </div>
)

export default FordjupningOchMal
